window.storeTheme = window.storeTheme || ({} as StoreTheme);

const removeChars = (str) => {
  var re = new RegExp('[\'"%#&*+()|<>\\/?]', 'g');
  return str.replace(re, ' ').trim();
};

/**
 * Filtra por receita dentro do banco de dados local de receitas
 *
 * @param searchText String
 * @returns
 */
const recipeFilter = async (searchText) => {
  const data = (
    await window.storeTheme.receitas.getItemsByFindParams({
      $or: [
        { name: { $regex: [searchText, 'i'] } },
        { shortname: { $regex: [searchText, 'i'] } },
        { categoriesNames: { $regex: [searchText, 'i'] } },
      ],
    })
  ).map((item) => {
    return {
      image: `<img src="${item.featuredImage}" title="Imagem" class="result-item-img" height="100" width="100" />`,
      title: item.name,
      link: item.link,
    };
  });
  return data;
};

const isSearchWord = (spected: 'contra' | 'swiftmais' | 'cartaopresente', text: string) => {
  switch (spected) {
    case 'contra':
      return ['contra', 'contrafile', 'contrafilé', 'contra-', 'contra file', 'contra filé'].includes(
        (text || '').toLowerCase().trim(),
      );
    case 'swiftmais':
      return ['swift mais', 'swiftmais', 'linha mais', 'mais', 'mais-'].includes((text || '').toLowerCase().trim());
    case 'cartaopresente':
      return [
        'cartao',
        'cartão',
        'gift',
        'card',
        'presente',
        'virtual',
        'digital',
        'carta',
        'vale',
        'cartaopresente',
      ].some((item) => text.toLowerCase().indexOf(item) > -1);
      break;
  }
};

const searchWordCartaoPresente = 'Cartão Presente Swift';

/**
 * Realiza uma busca diretamente na API de busca
 *
 * @param searchText string
 * @param signal AbortController.signal
 * @returns
 */
const requestSearch = async (searchText, signal) => {
  const key = `swift-search-result1--${searchText}`;
  try {
    let result = window.storeTheme.helpers.storage.read(key) as [];
    if (result && result?.length) {
      return result as [];
    }
    try {
      let filter, filterVal;
      if (isSearchWord('contra', searchText)) {
        filter = 'specificationFilter_99';
        filterVal = 'Swift%20Mais';
      } else if (isSearchWord('cartaopresente', searchText)) {
        searchText = searchWordCartaoPresente;
        filter = '';
        filterVal = '';
      } else {
        filter = 'specificationFilter_107';
        filterVal = 'Produtos';
      }
      const response = await fetch(
        `/api/catalog_system/pub/products/search/?ft=${removeChars(searchText)}${
          !!filter ? `&fq=${filter}:${filterVal}` : ''
        }&sc=${window.storeTheme.salesChannelSelector.getSalesChannel()}&O=OrderByTopSaleDESC`,
        { signal },
      );
      const products = await response.json();

      result = products
        .map((props) => {
          const { link, productReference, productName, items } = props;
          const sku = items.find((sku) => !!sku?.sellers?.[0]?.commertialOffer?.AvailableQuantity);
          if (sku) {
            const price = (sku.sellers.find((seller) => seller.sellerDefault) || {})?.commertialOffer?.Price;
            const addToCartLink = (sku.sellers.find((seller) => seller.sellerDefault) || {})?.addToCartLink;
            let filtred;
            try {
              filtred = {
                productReference,
                link,
                name: productName,
                complementName: sku?.complementName,
                measurementUnit: sku?.measurementUnit,
                price: window.storeTheme.helpers.format.money(price),
                customMeasureType: props?.['Unidade de Medidas']?.[0],
                customMeasureTypeClean: window.storeTheme.helpers.text.kebabCase(
                  (props?.['Unidade de Medidas'] || [])?.[0] || '',
                ),
                customMeasureValue: props?.['Quantidade dentro da unidade de medida']?.[0],
                image: ((sku?.images[0] || {})?.imageTag || '')
                  .replace('~', `//${window.jsnomeLoja}.vteximg.com.br`)
                  .replace(/\#width\#/g, '100')
                  .replace(/\#height\#/g, '100')
                  .replace('/>', 'class="result-item-img" />'),
                addToCartLink,
              };
            } catch (e) {
              console.error(e);
            }

            return filtred;
          }

          return false;
        })

        .filter((item) => !!item);
    } catch (e) {
      result = [];
    }
    if (result.length) {
      window.storeTheme.helpers.storage.save(key, result, 5);
    }
    return result;
  } catch (e) {
    console.error(e);
    return [];
  }
};

const search = (): void => {
  const $widgets = $('.search-wrap');
  const $body = $('body');

  if ($widgets.length) {
    $widgets.each((i, e) => {
      const $widget = $(e);
      const $form = $widget.find('form');
      const $widgetResult = $widget.find('.rnk-widget-search');
      const resultLimit = +$widget.attr('data-result-limit') || 4;
      const template = $widget.find('script[data-id="widget-search-template"]').text();
      const $input = $widget.find('.input-pesquisar');
      const $button = $widget.find('.btn-pesquisar');
      const $clear = $widget.find('.btn-clear');
      const $btnOpenSearch = $widget.find('.btn-open-search');
      const $loader = $widget.find('.search-loader');
      const tabitemsSelector = '.tabs-item-link';
      const tabContentsSelector = '.result-list';

      const getUrlToSearchpage = (term) => {
        const text = term.trim().toLowerCase();
        if (isSearchWord('swiftmais', text)) {
          return `/linha-swift-mais`;
        } else if (isSearchWord('contra', text)) {
          return `/bovinos/contra?O=OrderByTopSaleDESC`;
        } else if (isSearchWord('cartaopresente', text)) {
          return `/${searchWordCartaoPresente}`;
        }

        return `/busca?ft=${removeChars(text)}&fq=specificationFilter_107:Produtos&O=OrderByTopSaleDESC`;
      };

      const fixValueToSearch = (term) => {
        let text = term.trim().toLowerCase();
        if (isSearchWord('contra', term)) {
          text = 'contrafilé';
        }
        if (isSearchWord('swiftmais', term)) {
          text = 'swift mais';
          $input.val(text);
        }
        if (isSearchWord('cartaopresente', term)) {
          text = searchWordCartaoPresente;
          $input.val(text);
        }
        return text;
      };

      const fnGoToSearch = (text) => {
        window.location.href = getUrlToSearchpage(text);
      };

      $btnOpenSearch.on('click', (event) => {
        event.preventDefault();
        $widget.toggleClass('widget-show');
        const action = $widget.hasClass('widget-show') ? 'addClass' : 'removeClass';
        $body[action]('widget-active');
        $widget[action]('active');
      });

      $button.on('click', (event) => {
        event.preventDefault();
        // if ($input.val() == 'swift mais') {
        //   window.location.href = '/linha-swift-mais';
        // } else {
        fnGoToSearch(fixValueToSearch($input.val()));
        // }
        // return;
      });

      $form.on('submit', (event) => {
        event.preventDefault();
        $button.trigger('click');
      });

      $widget.on('click', tabitemsSelector, (event) => {
        event.preventDefault();
        const $this = $(event.currentTarget);
        const $activeItem = $this.closest('.tabs-item');

        $activeItem.addClass('active').siblings().removeClass('active');

        $widget
          .find(tabContentsSelector)
          .filter(`[data-type="${$activeItem.attr('data-type')}"]`)
          .addClass('active')
          .siblings()
          .removeClass('active');
      });

      $clear.on('click', (event) => {
        event.preventDefault();

        $widget.removeClass('active');
        $widget.removeClass('loading');
        $input.val('');
      });

      if (template && $input.length) {
        window.storeTheme.helpers.mustache.parse(template);
        let controller;
        let signal;
        const fn = window.storeTheme.helpers.debounce(async (event) => {
          const searchTerm = fixValueToSearch(event.target.value.trim());
          const timestamp = new Date().getTime();

          try {
            if (!$widget.hasClass('loading')) {
              if (controller?.abort) {
                controller.abort();
              }
            }
          } catch (e) {
            console.error(e);
          }

          if (searchTerm.length) {
            $widget.addClass('active');
          } else {
            $widget.removeClass('active');
          }

          // if (event.keyCode == 13) {
          //   fnGoToSearch(searchTerm);
          //   return;
          // }

          if (searchTerm.length < 3) {
            $widget.removeClass('active');
            $widgetResult.html('');
            return;
          }

          $widget.addClass('active');
          $widget.addClass('loading');
          $loader.data('timestamp', timestamp);
          $loader.removeClass('d-none');
          controller = new AbortController();
          signal = controller.signal;

          const obj = {
            products: (await requestSearch(searchTerm, signal)).slice(0, resultLimit),
            receitas: await recipeFilter(searchTerm), // .slice(0, resultLimit),
            pageSearchUrl: getUrlToSearchpage(searchTerm),
          };

          if ($loader.data('timestamp') === timestamp) {
            $loader.addClass('d-none');
          }

          $widget.addClass('active').removeClass('loading');

          const html = window.storeTheme.helpers.mustache.render(template, obj);
          $widgetResult.html(html);
        }, 250);
        $input.on('keypress keyup focus paste input propertychange', fn);
        let timerClose;
        $input.on('blur', () => {
          timerClose = setTimeout(() => {
            if (!$input.is(':focus') && $(window).width() > 992) {
              $widget.removeClass('active');
            }
          }, 600);
        });
        $(document).on('click', (event) => {
          const $this = $(event.target);
          if (!$this.is($widget) && !$this.closest('.search-wrap').length && $(window).width() > 992) {
            $widget.removeClass('active');
            return;
          }
          if (timerClose) {
            clearTimeout(timerClose);
          }
        });
      }
    });
  }
};

Object.assign(window.storeTheme, { widgets: Object.assign(window.storeTheme.widgets || {}, { search }) });

search();

export default search;
